import { VendorGetOneUseCase } from '../../../../application';

export default class VendorGetOneService {

    async execute(event) {
        const data = await VendorGetOneUseCase(event);
        return data;
    }
}
